const municipalityCodesReducer = (state = [{code: "", description: ""}], action) => {
    switch (action.type) {
      case 'LANDLINK_MUNICIPALITY_CODES':
        return action.results;
      default:
        break;
    }
    return state;
  }
  
  export default municipalityCodesReducer;